module.exports = __webpack_public_path__ + "img/pc-bg01-mobile.39a0201a.png";